import { createFileRoute } from "@tanstack/react-router";
import Favorites from "@/pages/Favorites";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/favorites/")({
  head: () => routeHead("/uk/favorites/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Favorites />
  );
}
